/**
 * 价格数据Hook
 * 使用React Query管理价格数据获取
 */
import { useQuery } from '@tanstack/react-query';
import { getV2O5Prices, getFevPrices, type PriceQueryParams } from '../api/prices';
import type { PriceData } from '../types';

export function useV2O5Prices(params?: PriceQueryParams) {
  return useQuery<PriceData[], Error>({
    queryKey: ['prices', 'v2o5', params],
    queryFn: () => getV2O5Prices(params),
    staleTime: 5 * 60 * 1000, // 5分钟
  });
}

export function useFevPrices(params?: PriceQueryParams) {
  return useQuery<PriceData[], Error>({
    queryKey: ['prices', 'fev', params],
    queryFn: () => getFevPrices(params),
    staleTime: 5 * 60 * 1000,
  });
}
